import { render, staticRenderFns } from "./SwitchTheme.vue?vue&type=template&id=9ae26a08&scoped=true"
import script from "./SwitchTheme.vue?vue&type=script&lang=js"
export * from "./SwitchTheme.vue?vue&type=script&lang=js"
import style0 from "./SwitchTheme.vue?vue&type=style&index=0&id=9ae26a08&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae26a08",
  null
  
)

export default component.exports